import styled from 'styled-components';
import { CaptionRegularM } from '../../../../../styles/globals';
import { IThemeProvider } from '../../../../../styles/theme';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 17px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[90]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 1rem 0 4rem 0;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
  `}
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  width: 90%;
  line-height: 1;
  align-items: flex-start;
  overflow: hidden;
`;

export const DescriptionSegment = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 12px;
`;

export const Description = styled.div`
  letter-spacing: 0.07px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  p {
    margin: 0;
    padding: 0;
  }
`;

export const ShowButton = styled(CaptionRegularM)`
  cursor: pointer;
  text-decoration: underline;
  ${({ theme }) => `
    color: ${theme.colors.support.blue[100]};
  `}
`;

export const BlocksWrapper = styled.div`
  width: 100%;
`;

export const BottomWrapper = styled.div`
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
`;

export const RadarChartWrapper = styled.div`
  padding: 2rem 0;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.decy};
  `}
`;
